import clsx from 'clsx';
import React from 'react';

import { Loader, LoaderProps } from './Loader';

interface StyleProps {
  isLoading: boolean;
  wrapperProps?: React.CSSProperties;
  showMask?: boolean;
}

type LoadableContentProps = LoaderProps & StyleProps;

export interface LoadingWrapperProps extends LoadableContentProps {
  children?: React.ReactNode;
  hideContentWhileLoading?: boolean;
  fullHeight?: boolean;
}

// Component to wrap an area that will have a loading state
export const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
  children,
  isLoading,
  showMask = false,
  hideContentWhileLoading = false,
  wrapperProps = {},
  fullHeight = false,
  ...loaderProps
}) => {
  const wrapperStyle: React.CSSProperties = {
    ...wrapperProps,
    ...(!fullHeight &&
      !isLoading && {
        height: wrapperProps.height ?? 'inherit',
      }),
  };

  return (
    <div
      className={clsx({
        relative: isLoading,
        'flex w-full h-full justify-center': fullHeight,
        'h-full': !fullHeight && isLoading,
      })}
      style={wrapperStyle}
    >
      {hideContentWhileLoading && isLoading ? null : children}
      {isLoading ? (
        <div
          className={clsx(
            'absolute top-0 h-full w-full flex justify-center items-center',
            {
              'bg-black': showMask,
            },
          )}
        >
          <Loader {...loaderProps} />
        </div>
      ) : null}
    </div>
  );
};
